import React from "react";
import OfferIcon from "@components/icons/Offer";
import { useTranslation } from "react-i18next";
import { ActiveSharedBetSlip } from "@data-types/chat";

export default function ChatRepliedMessagePreview(props: {
	betSlipData: ActiveSharedBetSlip;
	isMultiOffer: boolean;
}) {
	const { t } = useTranslation();

	if (!props.betSlipData) {
		return null;
	}

	const {
		eventCount,
		maxCoefficient,
		dateCreated,
		sportAbrv,
		firstEventName,
	} = props.betSlipData;

	return (
		<div className="chat__reply__slip">
			<div className="chat__slip__header">
				<OfferIcon
					type="sport"
					sport={sportAbrv}
					className="chat__icon__primary u-icon u-icon--lrg"
				/>
				{props.isMultiOffer && (
					<i className="u-icon u-icon--bb--active u-icon--base"></i>
				)}
				<span className="chat__slip__count">{eventCount}</span>
				<span className="chat__slip__title">{firstEventName}</span>
			</div>

			<div className="chat__slip__footer">
				<span>
					{t("BET_SLIP.MAX_COEF")}: <strong>{maxCoefficient}</strong>
				</span>
				<span className="u-color--text--tertiary">{dateCreated}</span>
			</div>
		</div>
	);
}
